import { subscribeKey as subKey } from 'valtio/vanilla/utils';
import { proxy } from 'valtio/vanilla';
import { OptionsController } from './OptionsController.js';
// -- State --------------------------------------------- //
const state = proxy({
    message: '',
    variant: 'info',
    open: false
});
// -- Controller ---------------------------------------- //
export const AlertController = {
    state,
    subscribeKey(key, callback) {
        return subKey(state, key, callback);
    },
    open(message, variant) {
        const { debug } = OptionsController.state;
        const { shortMessage, longMessage } = message;
        if (debug) {
            state.message = shortMessage;
            state.variant = variant;
            state.open = true;
        }
        if (longMessage) {
            // eslint-disable-next-line no-console
            console.error(typeof longMessage === 'function' ? longMessage() : longMessage);
        }
    },
    close() {
        state.open = false;
        state.message = '';
        state.variant = 'info';
    }
};
//# sourceMappingURL=AlertController.js.map